import cn from 'classnames'
import React , { Component, PropTypes } from 'react'
import { Tooltip } from 'nsky-ant'

export default class NskyLegend extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const ctx = this
        const {isShow, position, className, direction, legends } = this.props

        let myDirection = direction || 'horizontal'

        const myClassName = cn({
            'nsky-legend': true,
            'nsky-legend-horizontal': myDirection === 'horizontal',
            'nsky-legend-vertical': myDirection === 'vertical',
            'nsky-legend-hidden': !isShow,
            [className]: className
        })
        return (
            <div className={myClassName} style={position}>
                {
                    legends && legends.map((legend, index) => {
                        return (<div
                                key={index}
                                className="nsky-legend-item"
                                >
                                    {
                                        legend.title ? (<Tooltip title={legend.title}>
                                                <span className="nsky-legend-item-color" style={{'backgroundColor': legend.color}}></span>
                                            </Tooltip>) : (<span className="nsky-legend-item-color" style={{'backgroundColor': legend.color}}></span>)
                                    }

                                    <span className="nsky-legend-item-des">{legend.des}</span>
                                </div>)
                    })
                }
            </div>
        )
    }
}
NskyLegend.propTypes = {
    legends: PropTypes.arrayOf(PropTypes.shape({
        color: PropTypes.string.isRequired,
        des: PropTypes.string.isRequired
    })).isRequired,
    direction: PropTypes.string, // vertical, horizontal
    isShow: PropTypes.bool.isRequired,
    position: PropTypes.shape({
        left: PropTypes.any,
        top: PropTypes.any,
        right: PropTypes.any,
        bottom: PropTypes.any
    }).isRequired,
    className: PropTypes.string
}



/** WEBPACK FOOTER **
 ** ./src/nsky-legend.js
 **/